var _path, _path2, _circle, _path3, _circle2, _path4, _g, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailLinkedIn = function SvgMailLinkedIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9965 19.885C18.9965 24.8546 14.9678 28.8832 9.99824 28.8832C5.02865 28.8832 1 24.8546 1 19.885C1 14.9154 5.02865 10.8867 9.99824 10.8867C14.9678 10.8867 18.9965 14.9154 18.9965 19.885Z",
    fill: "white",
    stroke: "#3953FB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3033 22.6387L9.69138 23.2507C8.84648 24.0956 7.47662 24.0956 6.63172 23.2507C5.78682 22.4058 5.78682 21.0359 6.63172 20.191L7.24365 19.5791M12.751 20.191L13.363 19.5791C14.2079 18.7342 14.2079 17.3643 13.363 16.5194C12.5181 15.6745 11.1482 15.6745 10.3033 16.5194L9.69138 17.1313M8.48289 21.3995L11.5118 18.3706",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.028,
    cy: 7.91667,
    r: 7.41667,
    fill: "#3953FB",
    stroke: "#3953FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9414 5.89433L28.2068 8.03725C28.4712 8.21078 28.6034 8.29754 28.7472 8.33115C28.8743 8.36083 29.0071 8.36083 29.1342 8.33115C29.278 8.29754 29.4102 8.21078 29.6746 8.03725L32.94 5.89433M26.8611 10.7685H31.0203C31.6923 10.7685 32.0283 10.7685 32.2849 10.6459C32.5107 10.538 32.6942 10.366 32.8092 10.1543C32.94 9.91372 32.94 9.59874 32.94 8.96879V6.56922C32.94 5.93927 32.94 5.62429 32.8092 5.38368C32.6942 5.17204 32.5107 4.99997 32.2849 4.89213C32.0283 4.76953 31.6923 4.76953 31.0203 4.76953H26.8611C26.1891 4.76953 25.8532 4.76953 25.5965 4.89213C25.3707 4.99997 25.1872 5.17204 25.0722 5.38368C24.9414 5.62429 24.9414 5.93927 24.9414 6.56922V8.96879C24.9414 9.59874 24.9414 9.91372 25.0722 10.1543C25.1872 10.366 25.3707 10.538 25.5965 10.6459C25.8532 10.7685 26.1891 10.7685 26.8611 10.7685Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0827,
    cy: 30.0832,
    r: 7.41667,
    fill: "#3953FB",
    stroke: "#3953FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_796_278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 10,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.122 25.8843H25.9922V34.0186H34.122V25.8843Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_796_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8361 28.541H26.1309V33.9789H27.8361V28.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4195 28.4255C32.3567 28.4179 32.2898 28.4138 32.223 28.4097C31.9015 28.3921 31.5804 28.4528 31.2875 28.5865C30.9946 28.7203 30.7385 28.9231 30.5412 29.1777C30.5146 29.2118 30.4897 29.2472 30.4667 29.2838V28.557H28.8359V33.9949H30.5412V31.4408C30.5001 31.0668 30.5542 30.6884 30.6984 30.3409C30.7737 30.2073 30.8843 30.0971 31.0181 30.0222C31.1519 29.9474 31.3037 29.9109 31.4569 29.9167C31.5827 29.9084 31.709 29.9265 31.8274 29.9699C31.9459 30.0133 32.0539 30.0811 32.1446 30.1688C32.2353 30.2565 32.3066 30.3622 32.354 30.4791C32.4013 30.5961 32.4236 30.7216 32.4195 30.8477V34.0184H34.1248V30.4705C34.1248 29.2563 33.5082 28.5412 32.4195 28.4255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9824 27.8647C27.1782 27.8647 27.3697 27.8066 27.5325 27.6978C27.6953 27.589 27.8223 27.4343 27.8972 27.2534C27.9721 27.0725 27.9918 26.8734 27.9535 26.6813C27.9153 26.4892 27.821 26.3128 27.6826 26.1743C27.5441 26.0358 27.3676 25.9415 27.1756 25.9033C26.9835 25.8651 26.7844 25.8847 26.6035 25.9597C26.4225 26.0346 26.2679 26.1615 26.1591 26.3243C26.0503 26.4872 25.9922 26.6786 25.9922 26.8745C25.9922 27.1371 26.0965 27.3889 26.2822 27.5746C26.4679 27.7603 26.7198 27.8647 26.9824 27.8647Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4951 11.8867L17.9961 15.3861",
    stroke: "#3953FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4951 26.3839L17.9961 24.3843",
    stroke: "#3953FB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailLinkedIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mailLinkedIn.bd47b2a6.svg";
export { ForwardRef as ReactComponent };